.stickyNav {
  position: sticky;
  top: 0;
  max-height: calc(100vh - var(--sticky-nav-offset, 17.5rem));
  overflow: hidden;
  flex: 0 0 26.25rem;
  padding: 2rem 0 2rem 5rem;
  background-color: var(--bg-gray);
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
